import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TaskAddDialog from 'components/organisms/Dialogs/TaskAddDialog/TaskAddDialog';

const StyledEntitiesTaskAddDialog = styled(TaskAddDialog)`
  ${ComponentStyles}
`;

StyledEntitiesTaskAddDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesTaskAddDialog;
